<script lang="ts" setup>
const props = defineProps({
  blink: {
    default: false,
    type: Boolean,
  },
  color: {
    default: 'indigo',
    type: String as PropType<BaseCircleColor>,
  },
  hasGradient: {
    default: true,
    type: Boolean,
  },
  id: {
    default: '',
    type: String,
  },
})

const emit = defineEmits<{
  click: [id: string]
}>()

function onClick() {
  emit('click', props.id)
}
</script>

<template>
  <div
    class="relative flex-initial flex-shrink-0 overflow-hidden rounded-full"
    :class="{ 'animate-blink': blink }"
    @click="onClick"
  >
    <span
      class="absolute"
      :class="{
        'bottom-0 right-0 size-1/2': hasGradient,
        'inset-0': !hasGradient,
        'bg-gray-700': color === 'gray',
        'bg-blue-700': color === 'blue',
        'bg-green-700': color === 'green',
        'bg-indigo-700': color === 'indigo',
        'bg-orange-700': color === 'orange',
        'bg-pink-700': color === 'pink',
        'bg-purple-700': color === 'purple',
        'bg-red-700': color === 'red',
        'bg-teal-700': color === 'teal',
        'bg-white': color === 'white',
        'bg-yellow-700': color === 'yellow',
      }"
    />

    <div
      v-if="hasGradient"
      class="absolute inset-y-0 left-0 h-full w-1/2"
      :class="{
        'bg-gray-500': color === 'gray',
        'bg-blue-500': color === 'blue',
        'bg-green-500': color === 'green',
        'bg-indigo-500': color === 'indigo',
        'bg-orange-500': color === 'orange',
        'bg-pink-500': color === 'pink',
        'bg-purple-500': color === 'purple',
        'bg-red-500': color === 'red',
        'bg-teal-500': color === 'teal',
        'bg-gray-200': color === 'white',
        'bg-yellow-500': color === 'yellow',
      }"
    />

    <div
      v-if="hasGradient"
      class="absolute right-0 top-0 size-1/2"
      :class="{
        'bg-gray-900': color === 'gray',
        'bg-blue-900': color === 'blue',
        'bg-green-900': color === 'green',
        'bg-indigo-900': color === 'indigo',
        'bg-orange-900': color === 'orange',
        'bg-pink-900': color === 'pink',
        'bg-purple-900': color === 'purple',
        'bg-red-900': color === 'red',
        'bg-teal-900': color === 'teal',
        'bg-gray-400': color === 'white',
        'bg-yellow-900': color === 'yellow',
      }"
    />
  </div>
</template>
